import { parse, isDate, differenceInYears } from "date-fns/index.js";
import { isPossiblePhoneNumber } from "react-phone-number-input";

export const phoneNumberRegex = /^(\+\d{1}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

export const parseDate = (value, originalValue) => {
  if (originalValue === "") {
    return undefined;
  }

  return isDate(originalValue)
    ? originalValue
    : parse(originalValue, "dd-MM-yyyy", new Date());
};

export const validateDateFormat = (date) => {
  return date ? date.getFullYear().toString().length === 4 : true;
};

export const isAtleast18 = (date: Date) => {
  return date ? differenceInYears(new Date(), date) >= 18 : true;
};

export const isValidUsername = (username: string) => {
  if (!username) {
    return true;
  }
  if (username.length > 30) {
      return false;
  }
  const pattern = /^[A-Za-z0-9_.]+$/;
  return pattern.test(username);
}

export const isFileSizeGreaterThanMax = (fileSize: number, maxSizeInMb: number): boolean => {
  const fileSizeInMB = fileSize / (1024 * 1024);

  return fileSizeInMB > maxSizeInMb;
}

export const isFileWithinDimensionLimit = (
  file: FileList,
  maxHeight: number,
  maxWidth: number
): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve(true);
      return;
    }

    const img = new Image();
    img.src = URL.createObjectURL(file[0]);

    img.onload = () => {
      if (img.width > maxWidth || img.height > maxHeight) {
        resolve(false);
      } else {
        resolve(true);
      }
    };

    img.onerror = reject;
  });
};

export const isValidPhoneNumber = (value: string) => {
  if (!value) return true;

  return isPossiblePhoneNumber(value);
}
